<template>
  <div class="classDetail">
    <div class="classDetail-top">
      <div class="top-l">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ name: 'managementclass' }">
            {{ $t("managementV2.classManagement") }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            {{ $t("managementV2.classDetails") }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="calss-info">
          <el-tooltip
            :disabled="classInfo.name && classInfo.name.length <= 30"
            effect="dark"
            :content="classInfo.name"
            placement="top-start"
          >
            <div class="info-name">
              <i></i>{{ formateContent(classInfo.name, 30) }}
            </div>
          </el-tooltip>
          <ul class="info">
            <li v-if="false">
              <span class="lable"> {{ $t("managementV2.major") }}&nbsp;:</span
              >&nbsp;&nbsp;{{ classInfo.major || "--" }}
              <i></i>
            </li>
            <li>
              <span class="lable"> {{ $t("managementV2.member") }}&nbsp;:</span
              >&nbsp;&nbsp;{{ classInfo.peopleNum || 0 }}
              <i></i>
            </li>
            <li>
              <span class="lable">
                {{ $t("managementV2.numberOfJobsCompleted") }}&nbsp;:</span
              >&nbsp;&nbsp;{{ classInfo.finishTaskNum || 0 }}
              <i></i>
            </li>
            <li>
              <span class="lable"> {{ $t("managementV2.average") }}&nbsp;:</span
              >&nbsp;&nbsp;{{ classInfo.averageScore || 0 }}
              <i></i>
            </li>
            <li v-if="false">
              <span class="lable"> {{ $t("common.creationTime") }}&nbsp;:</span
              >&nbsp;&nbsp;{{ classInfo.createTime || "--" }}
              <i></i>
            </li>
          </ul>
        </div>
        <div class="btn-bottom">
          <el-button
            type="primary"
            size="small"
            @click="addstudent"
            v-if="false"
          >
            {{ $t("managementV2.addStudents") }}
            <i class="icon-add"></i>
          </el-button>
          <el-button @click="batchhandlerExport" size="small" class="blurBtn">
            {{ $t("jobManagementV2.report") }}
          </el-button>
          <el-button
            @click="batchDeleteStudent"
            size="small"
            class="blurBtn"
            v-if="false"
            >{{ $t("common.del") }}
          </el-button>
        </div>
      </div>
      <div class="top-r">
        <div class="operation">
          <div class="operation-top">
            <el-button v-if="false" @click="handlerEditor" size="small" class="editorBtn"
              >{{ $t("common.edit") }}
            </el-button>
            <el-button
              @click="handlerExportClass"
              size="small"
              class="exportBtn"
            >
              {{ $t("jobManagementV2.report") }}
            </el-button>
            <el-button
              @click="handlerDeleteClass"
              size="small"
              class="deletBtn"
            >
              {{ $t("common.del") }}</el-button
            >
          </div>
          <div class="operation-bottom">
            <div class="search">
              <el-input
                v-model="searchVal"
                :placeholder="$t('managementV2.searchPlaceholder')"
                @input="changinput"
                clearable
                @clear="changeClear"
              >
              </el-input>
              <i @click="search"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="classDetail-table">
      <el-table
        height="100%"
        border
        :data="managementclassList"
        header-row-class-name="customHeader"
        @select="changeSelect"
        @select-all="changeSelectAll"
        @sort-change="sortChange"
        :row-key="(row) => row.id"
        ref="table"
      >
        <el-table-column
          type="selection"
          width="48"
          align="center"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column
          type="index"
          width="57"
          :label="$t('managementV2.number')"
          align="center"
        >
          <template slot-scope="{ $index }">
            {{ fromateIndex($index) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="aliasName"
          :label="$t('managementV2.studentName')"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            <span class="name" @click="handleDetail(row)">
              {{ row.aliasName || "--" }}
            </span>
          </template>
        </el-table-column>
        <!--  -->
        <el-table-column
          prop="cardNo"
          :label="$t('managementV2.studentNo')"
          align="center"
          sortable="custom"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.cardNo }}
          </template>
        </el-table-column>
        <el-table-column
          prop="loginPhone"
          :label="$t('managementV2.phone')"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.loginPhone || "--" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          :label="$t('managementV2.email')"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.email || "--" }}
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="joinTime"
          :label="$t('managementV2.joiningTime')"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.joinTime || "--" }}
          </template>
        </el-table-column> -->
        <el-table-column
          prop="finishTaskCount"
          :label="$t('managementV2.numberOfJobsCompleted')"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.finishTaskCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="averageScore"
          :label="$t('managementV2.average')"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ row.averageScore || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('managementV2.operation')"
          align="center"
          class-name="operate"
          show-overflow-tooltip
          width="120"
        >
          <template slot-scope="{ row }">
            <el-tooltip
              effect="dark"
              :content="$t('myMessageV2.changedetail')"
              placement="top"
            >
              <i class="icon-detail" @click="handleDetail(row)"></i>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" :content="$t('managementV2.modifyName')" placement="top">
              <i class="icon-update" @click="updateName(row)"></i>
            </el-tooltip> -->
            <el-tooltip
              effect="dark"
              :content="$t('managementV2.downloadReport')"
              placement="top"
            >
              <i class="icon-downloadreport" @click="downloadreport(row)"></i>
            </el-tooltip>
            <!-- <el-tooltip effect="dark" :content="$t('managementV2.delete')" placement="top">
              <i class="icon-delete" @click="handlerDeleteStudent(row.id)"></i>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        :total="totalRows"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-size="params.rows"
        :page-sizes="[10, 20, 30, 40]"
        layout="prev, pager, next, sizes"
      >
      </el-pagination>
    </div>
    <!-- 添加学生弹窗 -->
    <addstudent-dialog
      :addclassVisible="addstudentVisible"
      @handlerclassClose="handlerstudentClose"
      :addstudentId="addstudentId"
      @handlerStudentSuccess="handlerStudentSuccess"
    >
    </addstudent-dialog>
    <!-- 删除弹窗 -->
    <delete-dialog
      :deleteVisible="deleteVisible"
      @handlerdeleteClose="handlerdeleteClose"
      :deletTips="deletTips"
      :deleteId="deleteId"
      :deleteType="deleteType"
      :deleteIdList="selectList"
      @handlerdeleteSuccess="handlerdeleteSuccess"
    >
    </delete-dialog>
    <!-- 编辑弹窗 -->
    <editor-dialog
      :eidtorVisible="eidtorVisible"
      @handlereditorClose="handlereditorClose"
      :editorTitle="editorTitle"
      :editorType="editorType"
      :editorId="editorId"
      @handlereditorSuccess="handlereditorSuccess"
      :classInfo="classInfo"
    >
    </editor-dialog>
    <!-- 导出 -->
    <async-download-file
      :isDownloadLoading="isDownloadLoading"
      :asyncDownloadFun="asyncDownloadFun"
      @handleClose="handleDownloadClose"
    ></async-download-file>
  </div>
</template>
<script>
import {
  getClassStudentList,
  getClassById,
  downloadClassMultipleHomeworkReport,
  batchdownloadStudentreport,
} from "@/services/managements";
import addstudentDialog from "../../../components/addstudentDialog";
import deleteDialog from "../../../components/deleteDialog";
import editorDialog from "../../../components/editroDialog";
import AsyncDownloadFile from "@/components/async-download-file";
export default {
  name: "classDetail",
  data() {
    return {
      searchVal: "",
      managementclassList: [],
      totalRows: 0,
      params: {
        filter: {
          // companyCode: '',
          companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
            .code,
          classId: null,
        },
        page: 1,
        rows: 10,
        sort: {},
      },
      companyCode: JSON.parse(localStorage.getItem("userInfo")).selfCompany
        .code,
      classInfo: {},
      addstudentVisible: false,
      deleteVisible: false,
      eidtorVisible: false,
      queryData: {}, //跳转带入的参数
      addstudentId: null,
      editorId: null,
      editorTitle: "",
      editorType: "",
      deleteId: null,
      selectList: [], //选择的数据
      deleteType: "",
      deletTips: "",
      isDownloadLoading: false,
      asyncDownloadFun: () => {},
    };
  },
  components: {
    addstudentDialog,
    deleteDialog,
    editorDialog,
    AsyncDownloadFile,
  },
  created() {
    this.queryData = JSON.parse(this.$Base64.decode(this.$route.query.key));
    console.log(this.queryData);
  },
  mounted() {
    this.getClassByIdInfo();
    this.getClassStudentList();
  },
  computed: {},
  methods: {
    formateContent(value, length) {
      if (value) {
        let str = value && value.toString();
        if (str.length > length) {
          return str.substring(0, length) + "...";
        } else {
          return str;
        }
      }
    },
    changeClear() {
      this.params.filter["name"] = "";
      this.getClassStudentList();
    },
    changinput() {
      this.searchVal = this.searchVal.replace(/^\s*/g, "");
    },
    //格式化序号
    fromateIndex(index) {
      if (index < 9) {
        return "0" + (index + 1);
      } else {
        return index + 1;
      }
    },
    //获取顶部班级信息
    async getClassByIdInfo() {
      const { result, success } = await getClassById({
        id: this.queryData.id,
        companyCode: this.companyCode,
      });
      if (success) {
        this.classInfo = result;
      }
    },
    //获取列表
    async getClassStudentList() {
      this.params.filter.classId = this.queryData.id;
      const { list, success, totalRows } = await getClassStudentList(
        this.params
      );
      if (success) {
        this.managementclassList = list;
        if (this.managementclassList.length === 0 && this.params.page > 1) {
          this.params.page--;
          this.getClassStudentList();
        }
        this.totalRows = totalRows;
        this.managementclassList.forEach((item) => {
          this.$set(item, "check", false);
        });
      }
    },
    // 排序
    sortChange({ prop, order }) {
      this.params.sort = {};
      this.params.sort[prop] = order === "ascending" ? "asc" : order === "descending" ? "desc" : null;
      if(order == null){
        this.params.sort ={}
      }
      this.getClassStudentList();
    },
    //添加学生
    addstudent() {
      this.addstudentVisible = true;
      this.addstudentId = this.queryData.id;
    },
    //关闭添加学生
    handlerstudentClose(val) {
      if (val) {
        this.getClassByIdInfo();
        this.getClassStudentList();
      }
      this.addstudentVisible = false;
    },
    //成功添加学生
    handlerStudentSuccess() {
      this.addstudentVisible = false;
      this.getClassByIdInfo();
      this.getClassStudentList();
    },
    //编辑
    handlerEditor() {
      this.editorTitle = this.$t("managementV2.NameEdit");
      this.editorType = "editorInfo";
      this.editorId = this.queryData.id;
      this.$set(this.classInfo, "aliasName", "");
      this.eidtorVisible = true;
    },
    //修改姓名
    updateName(row) {
      this.editorTitle = this.$t("managementV2.Nameeditor");
      this.editorType = "editorName";
      this.editorId = row.id;
      this.$set(this.classInfo, "aliasName", row.aliasName);
      this.eidtorVisible = true;
    },
    handlereditorClose() {
      this.eidtorVisible = false;
    },
    //编辑姓名成功
    handlereditorSuccess() {
      this.eidtorVisible = false;
      if (this.editorType === "editorInfo") {
        this.getClassByIdInfo();
      } else {
        this.getClassStudentList();
      }
    },
    //导出班级报告
    handlerExportClass() {
      if (parseInt(this.classInfo.finishTaskNum) === 0) {
        this.$message.closeAll();
        this.$message.warning(
          this.$t(
            "managementV2.Thenumberofjobscompletedis0Downloadingreportsisnotsupported"
          )
        );
        return;
      }
      this.asyncDownloadFun = () =>
        downloadClassMultipleHomeworkReport({
          companyDepartId: this.classInfo.id,
          companyCode: this.companyCode,
        });
      this.isDownloadLoading = true;
    },
    handleDownloadClose() {
      this.asyncDownloadFun = () => {};
      this.isDownloadLoading = false;
      this.$refs.table.clearSelection();
    },
    //批量导出学生报告
    batchhandlerExport() {
      if (this.selectList.length == 0) {
        return this.$message.warning(
          this.$t(
            "managementV2.Pleaseselectstudentswhowanttoexportreportsinbatch"
          )
        );
      }
      let exportIdLists = [];
      this.selectList.forEach((item) => {
        if (item.finishTaskCount > 0) {
          exportIdLists.push(item.userId);
        }
      });
      if (exportIdLists.length === 0) {
        this.$message.closeAll();
        this.$message.warning(
          this.$t(
            "managementV2.Thenumberofjobscompletedis0Downloadingreportsisnotsupported"
          )
        );
        return;
      }
      let params = {
        companyDepartId: this.classInfo.id,
        userIdList: exportIdLists,
        companyCode: this.companyCode,
      };
      this.asyncDownloadFun = () => batchdownloadStudentreport(params);
      this.isDownloadLoading = true;
      this.selectList.length = 0;
    },
    //删除班级
    handlerDeleteClass() {
      this.deleteVisible = true;
      this.deletTips = this.$t("managementV2.Areyousuretodeletethisclassdata");
      this.deleteType = "class";
      this.deleteId = this.queryData.id;
    },
    //删除学生
    handlerDeleteStudent(id) {
      this.selectList = [];
      this.deleteVisible = true;
      this.deletTips = this.$t(
        "managementV2.Areyousuretodeletethisstudentdata"
      );
      this.deleteType = "student";
      this.selectList.push(id);
    },
    //批量删除
    batchDeleteStudent() {
      let deleteIdList = [];
      this.selectList.forEach((item) => {
        deleteIdList.push(item.id);
      });
      this.selectList = deleteIdList;
      if (this.selectList.length == 0) {
        return this.$message.warning(
          this.$t("managementV2.Pleaseselectthestudenttodelete")
        );
      }
      this.deleteVisible = true;
      this.deletTips = this.$t(
        "managementV2.Areyousuretodeletethecheckedstudentdata"
      );
      this.deleteType = "student";
    },
    //关闭删除弹窗
    handlerdeleteClose() {
      this.$refs.table.clearSelection();
      this.deleteVisible = false;
      this.selectList = [];
    },
    //删除成功
    handlerdeleteSuccess() {
      this.deleteVisible = false;
      this.selectList = [];
      if (this.deleteType === "class") {
        this.$router.push({
          name: "managementclass",
        });
        return;
      }
      this.$refs.table.clearSelection();
      this.getClassByIdInfo();
      this.getClassStudentList();
    },
    //搜索内容
    search() {
      this.params.page = 1;
      this.params.filter["name"] = this.searchVal;
      this.getClassStudentList();
    },
    changeSelect(value, selectRow) {
      this.selectList = value;
    },
    changeSelectAll(value) {
      if (value.length > 0) {
        this.managementclassList.forEach((item) => {
          this.$set(item, "check", true);
        });
        let selectList = [...value, ...this.selectList];
        this.selectList = [...new Set(selectList)];
      } else {
        this.managementclassList.forEach((item) => {
          this.$set(item, "check", false);
        });
        this.selectList = [];
      }
    },
    //查看详情
    handleDetail(row) {
      this.$router.push({
        name: "studentdetail",
        query: {
          key: this.$Base64.encode(
            JSON.stringify({
              classId: this.queryData.id,
              aliasName: row.aliasName,
              major: row.major,
              loginPhone: row.loginPhone,
              email: row.email,
              averageScore: row.averageScore,
              finishTaskCount: row.finishTaskCount,
              joinTime: row.joinTime,
              userId: row.userId,
              id: row.id,
            })
          ),
        },
      });
    },
    //下载报告
    downloadreport(row) {
      if (row.finishTaskCount === 0) {
        this.$message.closeAll();
        this.$message.warning(
          this.$t(
            "managementV2.Thenumberofjobscompletedis0Downloadingreportsisnotsupported"
          )
        );
        return;
      }
      let params = {
        companyDepartId: this.classInfo.id,
        userIdList: [row.userId],
        companyCode: this.companyCode,
      };
      this.asyncDownloadFun = () => batchdownloadStudentreport(params);
      this.isDownloadLoading = true;
    },
    //切换页码
    handleCurrentChange(val) {
      this.params.page = val;
      this.getClassStudentList();
    },
    //切换当前最大条数
    handleSizeChange(newrows) {
      this.params.rows = newrows;
      this.getClassStudentList();
    },
  },
};
</script>
<style lang="less" scoped>
@import "./style.less";
</style>